<div class="container container-width ">
  <div class="border-bottom-1 d-flex w-100 mb-10 mt-1">
    <ul class="nav nav-tabs" role="list">
      <li class="nav-item" (click)="selectedTab = 'all'; showTable = true">
        <a id="tab-all" href="javascript:void(0)" class="form-box fw-600 nav-link"
          [ngClass]="{'bg-white border-1':selectedTab==='all', 'active': selectedTab==='all'}" role="tab"
          [attr.aria-selected]="selectedTab==='all'" aria-controls="panel-all" tabindex="0"
          (keydown.enter)="selectedTab = 'all'; showTable = true"
        (keydown.space)="selectedTab = 'all'; showTable = true">eCitation Delivery Summary</a>
      </li>

      <li class="nav-item" (click)="selectedTab = 'collectionList'; showTable=false">
        <a id="tab-collection" href="javascript:void(0)" class="ml-3 form-box fw-600 nav-link"
          [ngClass]="{'bg-white border-1':selectedTab=='collectionList', 'active': selectedTab==='collectionList'}"
          role="tab" [attr.aria-selected]="selectedTab==='collectionList'" aria-controls="panel-collection"
          tabindex="0" (keydown.enter)="selectedTab = 'collectionList'; showTable=false"
        (keydown.space)="selectedTab = 'collectionList'; showTable=false">eCitation Collection Summary</a>
      </li>

      <li class="nav-item" (click)="selectedTab = 'eCitationDelivery'; showTable=false">
        <a id="tab-delivery" href="javascript:void(0)" class="ml-3 form-box fw-600 nav-link"
          [ngClass]="{'bg-white border-1':selectedTab =='eCitationDelivery', 'active': selectedTab==='eCitationDelivery'}"
          role="tab" [attr.aria-selected]="selectedTab==='eCitationDelivery'" aria-controls="panel-delivery"
          tabindex="0" (keydown.enter)="selectedTab = 'eCitationDelivery'; showTable=false"
        (keydown.space)="selectedTab = 'eCitationDelivery'; showTable=false">eCitation Delivery Table</a>
      </li>
    </ul>
  </div>

  <!-- Panel: Delivery Summary -->
  @if (showTable) {
    <div class="table-container w-100" id="panel-all" role="tabpanel" aria-labelledby="tab-all">
      <table>
        <caption>eCitation Delivery Summary</caption>
        <thead>
          <tr>
            <th scope="col">Destination System</th>
            <th scope="col">Queued</th>
            <th scope="col">Delivered</th>
            <th scope="col">Failed</th>
            <th scope="col">Rejected</th>
          </tr>
        </thead>
        <tbody>
          <!-- rows populated elsewhere -->
        </tbody>
      </table>
    </div>
  }

  <!-- Panel: Collection Summary -->
  @if (selectedTab === 'collectionList') {
    <div class="table-container w-100" id="panel-collection" role="tabpanel"
      aria-labelledby="tab-collection">
      <table>
        <caption>eCitation Collection Summary</caption>
        <thead>
          <tr>
            <th scope="col">Status</th>
            <th scope="col">Count</th>
          </tr>
        </thead>
        <tbody>
          <!-- rows populated elsewhere -->
        </tbody>
      </table>
    </div>
  }

  <!-- Panel: Delivery Table -->
  @if (selectedTab === 'eCitationDelivery') {
    <div class="table-container w-100" id="panel-delivery" role="tabpanel"
      aria-labelledby="tab-delivery">
      <div class="d-flex justify-content-between align-items-center"></div>
      <table>
        <caption>eCitation Delivery Table</caption>
        <thead>
          <tr>
            @for (col of tableHeaders; track col) {
              <th scope="col">
                {{col.header}}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of tableData; track item) {
            <tr>
              <td>{{item.CitationNumber}}</td>
              <td>{{item.IssuedBy}}</td>
              <td>{{item.Transmitted}}</td>
              <td>{{item.Disposition}}</td>
              <td>{{item.Destination}}</td>
              <td>{{item.Attempts}}</td>
              <td>{{item.Status}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
